export class IFeeDetailPrint {
    invoice: string;
    createdDate: Date;
    startDate: Date;
    endDate: Date;
    membershipNumber: string;
    memberName: string;
    addedBy?: string;
    feeType: string;
    /** Book-trainer only — hide pkg/trainer rows on membership receipts */
    showTrainerBookingDetails?: boolean;
    packageType?: string;
    packageName?: string;
    trainerName?: string;
    fee: string;
    tax: string;
    discount: string;
    taxRate: number;
    taxCalculationType: string;
    paymentMode: string;
    /** Subscription receipts — start and expiry under mode of payment */
    showSubscriptionPeriod?: boolean;
    /** Remaining obligation after partial payment (trainer booking / split). */
    balance?: string | number;
    SRBInvoiceID?: string;
    /** Split subscription: both SRB ids from parent SRBInvoiceIDs */
    SRBInvoiceIDs?: string[];
    FBRInvoiceID?: string;
    FBRInvoiceIDs?: string[];
}
